module.exports = __webpack_public_path__ + "img/旅游活动-1@2x.cd497158.png";